
export default [
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'select-custom',
        field: 'replicar',
        label: 'Replicar Função para os Seguintes GHE',
        multiple: [],
        option: {
            key: 'id',
            label: 'ghe',
            value: 'id'
        },
        title: {
            model: 'replicar_subs',
        },
        info: 'Caso essa medição seja igual em vários GHE, você pode replicar essa configuração em vez de cadastrar individualmente para cada setor.',
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'select-custom',
        field: 'id_fun',
        label: 'Função',
        option: {
            key: 'id',
            label: 'nome',
            value: 'id'
        },
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'text',
        field: 'cbo',
        label: 'CBO',
        mask:'cbo',
        maxlength:45,
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'textarea',
        field: 'descricao',
        label: 'Descrição',
        rules: ['required']
    },

];




// WEBPACK FOOTER //
// ./src/components/apps/web/ltcat/ghe/_form/ltcat-ghe-funcao-cadastrar.js